AgrimarketControllers.controller('userContractsV2CurrentController', ['$scope', '$rootScope', 'contractsService', 'cropsService', '$sce', 'columns', 'offerService', 'enumFactory', '$location',
    function ($scope, $rootScope, contractsService, cropsService, $sce, columns, offerService, enumFactory, $location) {

        var Init = function () {
            // Contrats fixés
            $scope.tableDataVisible = columns.data.DataVisible.split(',');
            $scope.tableLibelle = columns.data.ColumnName.split(',');

            // Gestion du trie
            $scope.reverse = true;
            $scope.sortKey = "IdContractCommitment";
            $scope.pageNo = 1;
            $scope.max = 10;

            $scope.currentView = "Current";
            $scope.idProductSelected = "";
            $scope.idCropSelected = $rootScope.crop.IdCrop;

            $scope.allowUserToSubscribreToday = false;

            GetContracts();
        };

        $scope.$watch("selectedIdContract", function (newValue, oldValue) {
            if ((newValue && oldValue !== newValue) || (!newValue && oldValue))
                $scope.GetContractsWithFilter();
        });

        var AllowUserToSubscribreToday = function () {
            offerService.AllowUserToSubscribreToday(function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.allowUserToSubscribreToday = false;
                } else {
                    $scope.allowUserToSubscribreToday = data === "true";
                }
            });
        };

        var GetFiltersWithContracts = function () {
            $scope.loading = true;
            $scope.idProductSelected = "";
            $scope.selectedIdContract = "";
            $scope.All = $rootScope.editableObjectsFactory.EditableObjects.All.Content;
            contractsService.GetFiltersForUserContractsCurrentByCrop($scope.idCropSelected, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    if (data) {

                        $scope.lstProducts = data.LstProductVm;

                        if ($scope.lstProducts.length === 1)
                            $scope.idProductSelected = $scope.lstProducts[0].Id;
                        else if ($scope.lstProducts.length > 1)
                            $scope.lstProducts.unshift({ Id: "", Label: $scope.All });

                        $scope.GetContractsWithFilter();
                    }
                }
            });
        };

        var GetDefaultCrop = function (callback) {
            cropsService.GetDefaultCrop(function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    if (data !== null) {
                        $scope.idCropSelected = data.IdCrop;
                        callback();
                    }
                }
            });
        };

        var GetContracts = function () {
            if (!$scope.idCropSelected) //Si on a pas de récolte de sélectionnée on prend celle par défaut
                GetDefaultCrop(GetContracts());
            else
                GetFiltersWithContracts();

            AllowUserToSubscribreToday();
        };

        $scope.GetContractsWithFilter = function () {
            if (!$scope.selectedIdContract) $scope.selectedIdContract = "";
            $scope.loading = true;
            contractsService.GetUserContractsCurrentPaginate($scope.idCropSelected, $scope.idProductSelected, $scope.selectedIdContract, $scope.max, $scope.pageNo, $scope.sortKey, $scope.reverse, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    $scope.total = data.Total;
                    $scope.contractCommitments = data.ListVm;
                    $scope.contractCommitments.forEach(function (item) {
                        item.showDetail = true;
                    });
                    $scope.loading = false;

                    AllowUserToSubscribreToday();
                }
            });
        };

        $scope.Sort = function (sortKey, reverse) {
            $scope.sortKey = sortKey;
            $scope.reverse = reverse;
            $scope.GetContractsWithFilter();
        };

        $scope.GetData = function (pageNo) {
            $scope.pageNo = pageNo;
            $scope.GetContractsWithFilter();
        };

        $scope.GoToSubscribe = function (contract, idTypeOrder, idTypeFixation) {

            $rootScope.idTypeOrderSelected = idTypeOrder;
            $rootScope.idTypeCommitmentSelected = null;

            if (contract.IsLastLineQuantityRemaining && !contract.IsOnlyOneOfferExpiry) {
                $location.path('/user/offers/view/' + enumFactory.TypeOffer.Ferme + '/' + contract.IdContractCommitment);
            } else {
                $rootScope.idOfferSelected = contract.IdOffer;
                $rootScope.idExpirySelected = contract.IdExpiry;
                switch (idTypeFixation) {
                    case enumFactory.TypeFixations.Base.IdTypeFixation:
                        $location.path('/user/subscribe/contractBase/' + (contract.IdContractCommitment ? contract.IdContractCommitment : '') + '/' + (contract.IdContract ? contract.IdContract : ''));
                        break;
                    case enumFactory.TypeFixations.Future.IdTypeFixation:
                    case enumFactory.TypeFixations.GlobalPrice.IdTypeFixation:
                        $location.path('/user/subscribe/contractFirm/' + (contract.IdContractCommitment ? contract.IdContractCommitment : '') + '/' + idTypeFixation + '/' + (contract.IdContractBase ? contract.IdContractBase : ''));
                        break;
                    default:
                        break;
                }
            }
        };

        $rootScope.onRefresh = function () {
            Init();
        };

        $scope.AsChangedCrop = function () {
            Init();
        };

        Init();
    }]);
